
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import classNames from 'classnames';
import AppLink from 'components/AppLink/AppLink';
import DeviceList from 'components/DeviceList';
import Layout from 'components/Layout';
import { useAuth } from 'context';
import { useLang } from 'context/langContext';
import { Namespace } from 'enums';
import { basicSEO, createRedirectIfNeeded, getNoTrialTranslationKeyIfNeeded, Permalink } from 'helpers';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import { StaticPathParams } from 'typings/staticPaths';
import indexStyles from '../index.module.scss';
import styles from './index.module.scss';

interface Props {
  countryCode: string;
}

const HowToWatchSmartTV = ({ countryCode }: Props): JSX.Element => {
  const { t } = useTranslation(Namespace.HowToWatch);
  const { locale } = useLang();
  const { user } = useAuth();

  return (
    <Layout countryCode={countryCode}>
      <Head>
        {basicSEO(
          t('seo:how_to_watch_tv_title'),
          t(getNoTrialTranslationKeyIfNeeded('seo:how_to_watch_tv_description', countryCode)),
        )}
      </Head>
      <main className={classNames(indexStyles.container, styles['smart-tv'])}>
        <h1>{t('title')}</h1>
        <DeviceList activeIndex={1} />
        <ul className={indexStyles.blocks}>
          <li>
            <h2 className={styles.samsung}>{t('smart_tv.samsung_title')}</h2>
            <p>{t('smart_tv.samsung_description')}</p>
            <AppLink href={Permalink.howToWatchSmartTVSamsung(locale)}>
              <a className={classNames('btn', 'btn-primary')}>{t('smart_tv.button')}</a>
            </AppLink>
          </li>
          <li>
            <h2 className={styles.lg}>{t('smart_tv.lg_title')}</h2>
            <p>{t('smart_tv.lg_description')}</p>
            <AppLink href={Permalink.howToWatchSmartTVLG(locale)}>
              <a className={classNames('btn', 'btn-primary')}>{t('smart_tv.button')}</a>
            </AppLink>
          </li>
        </ul>
      </main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { locale, apiClient, countryCode } = await authorizeUserServerSide(ctx);

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  return {
    props: { countryCode },
  };
}

export default HowToWatchSmartTV;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/how-to-watch/smart-tv/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  